import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/traversal/filter/filter.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/traversal/index/index.js";
import "dabbyjs/src/traversal/eq/eq.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/events/on/on.js";

export default (obj, animate = true) => {
	obj.each(function () {
		let timeout = null;
		const $this = $(this),
			cls = this.classList[0],

			// get the carousel switches
			inputs = $("." + cls + "__switch", $this),
			last = inputs.length - 1,

			// setup a timer to move to the next slide
			tick = () => {
				if (timeout === null) {
					timeout = setInterval(() => {
						const checked = inputs.index(inputs.filter(":checked")),
							index = checked > -1 ? checked : 0, // if none checked - set to first
							next = index < last ? index + 1 : 0;
						inputs.eq(next).prop("checked", true).trigger("change");
					}, 8000);
				}
			};
		
		// set first item and start the ticker
		$(window).on("load", () => {

			// turn off and on on hover
			if (animate) {
				$this
					.on("mouseleave touchend", tick)
					.on("mouseover touchstart", () => {
						clearInterval(timeout);
						timeout = null;
					});
			}

				// keyboard navigation for popup labels
			$this
				.on("keydown", "label[tabindex='0']", function (e) {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						$(this).trigger("click");
					}
				})

				// keyboard navigation for closing popups
				.on("keydown", "." + cls + "__content-bg", function(e) {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						$(this).trigger("click");
					}
				})

				// trap focus in open dialogs
				.on("keydown", "section[role='dialog']", function(e) {
					if (e.key === "Escape") {
						$(`#${cls}-close`).prop("checked", true).trigger("change");
					}
				});

			// adjust height as it slides
			inputs.on("change", function () {
				const height = $(this).next().get(0).scrollHeight;
				$this.css("height", height);
			});

			// start the carousel
			inputs.eq(0).prop("checked", true).trigger("change");
			if (animate) {
				tick();
			}
		});
	});
};